module.exports = __webpack_public_path__ + "static/img/77.94927da3.jpg";